import { Controller } from "@hotwired/stimulus"

// The picture you are about to choose, shown at the size it will be seen at.
// The choice itself is the radio the form submits; this only swaps what is on
// the stage, so picking still works with nothing running.
export default class extends Controller {
  static targets = ["stage", "credit"]

  show(event) {
    const chosen = event.target
    this.stageTarget.src = chosen.dataset.picture
    this.stageTarget.alt = chosen.dataset.alt || ""
    this.creditTarget.textContent = chosen.dataset.credit
  }
}
